/**
* @description 页面报错
* @date 2023-10-30 15:23:23
* @author 2028
*/
export default {
  namespaced: true,
  state: {
    isError: false, // 是否错误
    errorMsg: '', // 错误数据
  },
  mutations: {
    setIsError(state, flag) {
      state.isError = flag
    },
    setErrorMsg(state, msg) {
      state.errorMsg = msg
    },
    setError(state, { flag, msg }) {
      state.isError = flag
      state.errorMsg = msg
    }
  },
  actions: {}
}
